import { Avatar } from "@mui/material";

export default function Hero() {
  return (
    <div className="relative !mb-10">
      {/* Hero Image Section */}
      <div className="relative h-[80vh] w-full">
        {/* Text Content Positioned Over Image */}
        <div className="absolute inset-0 z-10 flex flex-col justify-center items-start container mx-auto px-4">
          <div className="max-w-3xl space-y-4 p-6 rounded-lg">
            {/* Tags */}
            <div
              className="max-w-3xl space-y-6 p-8 rounded-lg bg-gradient-to-br from-black/80 via-gray-900/60 to-black/80 shadow-lg"
              style={{
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
              }}
            >
              <div className="flex space-x-2">
                <span className="bg-green-500 text-white px-2 py-1 text-xs rounded">
                  R
                </span>
                <span className="bg-yellow-500 text-white px-2 py-1 text-xs rounded">
                  T
                </span>
                <span className="bg-green-500 text-white px-2 py-1 text-xs rounded">
                  S
                </span>
              </div>

              {/* Title */}
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                Latest tax updates and compliance guidelines
              </h1>

              <h6 className="text-2xl md:text-3xl font-bold text-white">
                Home /<span className="text-[#151C62]"> Blogs</span>
              </h6>
            </div>
          </div>
        </div>

        {/* Hero Image */}
        <img
          src="https://images.unsplash.com/photo-1554224155-a1487473ffd9?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Hero img"
          style={{ height: "80vh", width: "100%" }}
          className="object-cover"
        />
      </div>
    </div>
  );
}
